import { Badge } from './Badge';
import { Spinner } from './Spinner';

/**
 * The one mapping from a lifecycle status to how it looks.
 *
 * Scan statuses, schedule statuses and ticket statuses were each mapped to
 * colors in their own component (ScansTable, RecentScansTable, MonitoringPage,
 * SupportManagement…), and the maps had already drifted - "in progress" was
 * near-black in one table and blue in another. One table, one look.
 *
 * Raw backend statuses and the frontend-normalized ones both resolve, so this
 * is safe to use on data from any layer.
 */
const STATUS = {
	// Scans - active states get a spinner: motion is the honest signal.
	pending: { label: 'Pending', variant: 'warning' },
	initializing: { label: 'Starting', variant: 'brand', busy: true },
	queuing_jobs: { label: 'Starting', variant: 'brand', busy: true },
	processing: { label: 'In progress', variant: 'brand', busy: true },
	analyzing: { label: 'Analyzing', variant: 'brand', busy: true },
	in_progress: { label: 'In progress', variant: 'brand', busy: true },
	completed: { label: 'Completed', variant: 'success' },
	completed_with_errors: { label: 'Failed', variant: 'destructive' },
	failed: { label: 'Failed', variant: 'destructive' },
	cancelled: { label: 'Cancelled', variant: 'secondary' },

	// Schedules
	active: { label: 'Active', variant: 'success' },
	paused: { label: 'Paused', variant: 'warning' },
	error: { label: 'Error', variant: 'destructive' },

	// Tickets
	open: { label: 'Open', variant: 'brand' },
	waiting_for_user: { label: 'Waiting on user', variant: 'warning' },
	resolved: { label: 'Resolved', variant: 'success' },
	closed: { label: 'Closed', variant: 'secondary' },
};

export function StatusBadge({ status, className }) {
	const s = STATUS[status] || { label: status || 'Unknown', variant: 'secondary' };
	return (
		<Badge variant={s.variant} className={className}>
			{s.busy && <Spinner size="sm" className="mr-1.5 h-3 w-3" />}
			{s.label}
		</Badge>
	);
}

export default StatusBadge;
